import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import {formatDate} from "@angular/common";

export interface AlertMessage {
  id: string;
  type: string;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private static MAX_NUMBER_MESSAGES: number = 2;

  private messages = new BehaviorSubject<AlertMessage[]>([]);
  public messages$ = this.messages.asObservable();

  private keepAfterNavigationChange = false;

  private timers: { [key: string]: any } = {};

  constructor(private router: Router) {
    // clear alert message on route change
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.messages.next([]);
        }
      }
    });
  }

  public success(message: string, keepAfterNavigationChange = true): void {
    this.showMessage('success', message, keepAfterNavigationChange);
  }

  public error(message: string, keepAfterNavigationChange = true): void {
    this.showMessage('error', message, keepAfterNavigationChange);
  }

  public alert(e: Error): void {
    this.error('Ein unerwarteter Fehler aufgetreten.', true);
  }

  private showMessage(type: string, text: string, keepAfterNavigationChange: boolean = true): void {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    const message: AlertMessage = { id: AlertService.generateId(type), type: type, text: text };

    this.addMessage(message);
  }

  public getMessage(): Observable<AlertMessage[]> {
    return this.messages$;
  }

  private static generateId(type: string): string {
    console.log(formatDate(new Date(),'dd_HH_mm_SSS', 'de-DE'));
    return type + '_' + formatDate(new Date(),'dd_HH_mm_SSS', 'de-DE');
  }

  private deleteMessage(messageId: string): AlertMessage[] {
    if (this.timers[messageId]) {
      clearTimeout(this.timers[messageId]);
      delete this.timers[messageId];
    }

    const messages: AlertMessage[] = this.messages.getValue();
    this.messages.next(messages.filter(m => m.id !== messageId));

    return messages;
  }

  private addMessage(message: AlertMessage): AlertMessage[] {
    this.timers[message.id] = setTimeout(() => {
      this.deleteMessage(message.id);
    }, 10000);

    let messages: AlertMessage[] = this.messages.getValue();

    while (messages.length >= AlertService.MAX_NUMBER_MESSAGES) {
      messages = this.deleteMessage(messages[0].id);
    }

    messages.push(message);
    this.messages.next(messages);

    return messages;
  }
}
